import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function FooterCTA() {
  return <footer className="w-full bg-gradient-to-b from-rose-50 to-rose-100/50" data-id="element-27">
      {/* Final CTA Section */}
      <section className="py-10 md:py-12 px-6" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl mx-auto text-center" data-id="element-29">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-brown-dark mb-4 leading-tight" data-id="element-30">
            Hoy resolvés la cena.
            <br data-id="element-31" />
            Mañana el almuerzo.
            <br data-id="element-32" />
            <span className="text-orange" data-id="element-33">Esta semana, toda la semana.</span>
          </h2>

          <motion.blockquote initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="font-body text-lg md:text-xl text-brown-light italic mb-8 px-6 py-4 border-l-4 border-orange bg-orange/5 rounded-r-xl" data-id="element-34">
            "30 recetas rescate + sistema completo por menos de lo que gastás en
            2 deliveries."
          </motion.blockquote>

          <motion.a href="https://www.mamaexpres.com/cart/53191481131281:1" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-3 px-10 py-5 bg-orange text-white font-bold text-xl rounded-full shadow-warm-lg hover:bg-orange-dark hover:shadow-warm-xl transition-all duration-300" data-id="element-35">
            ¡Quiero mis Recetas Rescate!
            <ArrowRightIcon className="w-6 h-6" data-id="element-36" />
          </motion.a>
        </motion.div>
      </section>

      {/* Simple Footer */}
      <div className="py-6 px-6 border-t border-brown-light/10" data-id="element-37">
        <div className="flex flex-col items-center gap-3" data-id="element-38">
          <img src="https://cdn.magicpatterns.com/uploads/phjtk1bgZ2Wg5PQ3624S8A/logo_mama_expres-_ok.png" alt="Mamá Exprés Digital" className="w-12 h-12 rounded-full object-cover" data-id="element-39" />
          <p className="text-center text-sm text-brown-muted" data-id="element-40">
            © {new Date().getFullYear()} Mamá Exprés Digital. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}